import { render, staticRenderFns } from "./PhotoPhone.vue?vue&type=template&id=3c1f4c96&scoped=true"
import script from "./PhotoPhone.vue?vue&type=script&lang=js"
export * from "./PhotoPhone.vue?vue&type=script&lang=js"
import style0 from "./PhotoPhone.vue?vue&type=style&index=0&id=3c1f4c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f4c96",
  null
  
)

export default component.exports